module.exports = __webpack_public_path__ + "img/bg.ef72fa3d.png";